define('ui/save-html',["exports", "core/ui", "core/l10n", "core/pubsubhub", "core/exporter", "deps/hyperhtml"], function (exports, _ui, _l10n, _pubsubhub, _exporter) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.show = show;
  exports.exportDocument = exportDocument;
  const name = exports.name = "ui/save-html";

  // Create and download an EPUB 3 version of the content
  // Using (by default) the EPUB 3 conversion service set up at labs.w3.org/epub-generator
  // For more details on that service, see https://github.com/iherman/respec2epub
  // Module ui/save-html
  // Saves content to HTML when asked to
  const epubURL = new URL("https://labs.w3.org/epub-generator/cgi-bin/epub-generator.py");
  epubURL.searchParams.append("type", "respec");
  epubURL.searchParams.append("url", document.location.href);

  const downloadLinks = [{
    id: "respec-save-as-html",
    fileName: "index.html",
    title: "HTML",
    type: "text/html",
    get href() {
      return (0, _exporter.rsDocToDataURL)(this.type);
    }
  }, {
    id: "respec-save-as-xml",
    fileName: "index.xhtml",
    title: "XML",
    type: "application/xml",
    get href() {
      return (0, _exporter.rsDocToDataURL)(this.type);
    }
  }, {
    id: "respec-save-as-epub",
    fileName: "spec.epub",
    title: "EPUB 3",
    type: "application/epub+zip",
    href: epubURL.href
  }];

  function toDownloadLink(details) {
    const { id, href, fileName, title, type } = details;
    return hyperHTML`
    <a
      href="${href}"
      id="${id}"
      download="${fileName}"
      type="${type}"
      class="respec-save-button"
      onclick=${() => _ui.ui.closeModal()}
    >${title}</a>`;
  }

  const saveDialog = {
    async show(button) {
      await document.respecIsReady;
      const div = hyperHTML`
      <div class="respec-save-buttons">
        ${downloadLinks.map(toDownloadLink)}
      </div>`;
      _ui.ui.freshModal(_l10n.l10n[_l10n.lang].save_snapshot, div, button);
    }
  };

  const supportsDownload = "download" in HTMLAnchorElement.prototype;
  let button;
  if (supportsDownload) {
    button = _ui.ui.addCommand(_l10n.l10n[_l10n.lang].save_snapshot, "ui/save-html", "Ctrl+Shift+Alt+S", "💾");
  }

  function show() {
    if (!supportsDownload) return;
    saveDialog.show(button);
  }

  function exportDocument(format, mimeType) {
    const msg = "Exporting via ui/save-html module's `exportDocument()` is deprecated and will be removed. " + "Use core/exporter `rsDocToDataURL()` instead.";
    (0, _pubsubhub.pub)("warn", msg);
    console.warn(msg);
    return (0, _exporter.rsDocToDataURL)(mimeType);
  }
});
//# sourceMappingURL=save-html.js.map;
